<template>
  <div>
    <portal to="settings-header">
      <span>
        <v-btn
          small
          color="primary"
          class="text-none"
          @click="addNewEntry"
          :class="$vuetify.breakpoint.smAndDown ? '' : 'ml-4'"
        >
          <v-icon
            left
            small
            v-text="'mdi-plus'"
          ></v-icon>
          {{ $t('addNew') }}
        </v-btn>
        <v-btn
          small
          outlined
          color="success"
          class="text-none"
          @click="saveNewEntry"
          :class="'ml-2'"
          v-if="showSaveBtn"
          :loading="saving"
          :disabled="saving"
        >
          {{ $t('save') }}
        </v-btn>
        <v-btn
          small
          outlined
          color="error"
          class="text-none"
          @click="deleteEntry"
          :class="'ml-2'"
          v-if="showDeleteBtn"
          :loading="deleting"
          :disabled="deleting"
        >
          {{ $t('delete') }}
        </v-btn>
        <v-btn
          small
          outlined
          color="primary"
          class="text-none ml-2"
          @click="refreshUi"
        >
          <v-icon small v-text="'mdi-refresh'" left></v-icon>
          {{ $t('refresh') }}
        </v-btn>
        <v-btn
          small
          outlined
          color="primary"
          class="text-none ml-2"
          @click="onBtnExport"
        >
          <v-icon small v-text="'$download'" left></v-icon>
          {{ $t('export') }}
        </v-btn>
        <v-btn
          small
          outlined
          color="primary"
          class="text-none ml-2"
          @click="downloadSample"
        >
          <v-icon small v-text="'$download'" left></v-icon>
          {{ $t('downloadCSV') }}
        </v-btn>
        <v-btn
          small
          outlined
          color="primary"
          class="text-none ml-2"
          @click="uploadFile"
        >
          <v-icon small v-text="'$upload'" left></v-icon>
          {{ $t('Import') }}
        </v-btn>
        <input
          type="file"
          accept=".csv"
          ref="uploader"
          class="d-none"
          id="uploadFiles"
          @change="onFilesChanged"
        >
      </span>
    </portal>
    <v-tabs
      v-if="showTabs(id)"
      v-model="tab"
      :background-color="$vuetify.theme.dark ? '#121212': ''"
    >
      <v-tab
        :key="asset.id"
        class="text-none"
        :disabled="loading"
        v-for="asset in getAssets(id)"
      >
      <span v-text="$t(asset.assetName)"></span>
    </v-tab>
    </v-tabs>
     <base-master
      :assetId="assetId"
      :id="id"
      v-if="id"
      ref="base"
      :fetchData="loading"
      @savebtnshow="visibleSaveBtn"
      @deletebtnshow="visibleDeleteBtn"
      @loading="onLoading"
      @saving="onSaving"
    />
    <import-master-data
      ref="importer"
      :id="id"
      :assetId="assetId"
      :records="tags"
      @on-imported="refreshUi"
      @on-close-dialog="resetForm"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import BaseMaster from '../components/BaseMaster.vue';
import ImportMasterData from '../components/import/ImportMasterData.vue';

export default {
  name: 'MasterWindow',
  components: {
    BaseMaster,
    ImportMasterData,
  },
  data() {
    return {
      base: '',
      tab: 0,
      showSaveBtn: false,
      showDeleteBtn: false,
      loading: false,
      saving: false,
      deleting: false,
    };
  },
  mounted() {
    this.base = this.$refs.base;
  },
  computed: {
    ...mapGetters('masters', ['showTabs', 'getAssets', 'getTags']),
    id() {
      return this.$route.params.id;
    },
    idOrTab() {
      return `${this.id}|${this.tab}`;
    },
    assetId() {
      if (this.showTabs(this.id)) {
        return this.getAssets(this.id)[this.tab].id;
      }
      if (this.getAssets(this.id).length === 1) {
        return this.getAssets(this.id)[0].id;
      }
      return 0;
    },
    tags() {
      return this.getTags(this.id, this.assetId);
    },
  },
  watch: {
    id(val) {
      if (val) {
        this.tab = 0;
        setTimeout(() => {
          this.base = this.$refs.base;
        }, 100);
      }
    },
    idOrTab() {
      if (this.base) {
        this.fetchingData();
      }
    },
  },
  methods: {
    ...mapActions('masters', ['deleteRecord']),
    ...mapMutations('helper', ['setAlert']),
    fetchingData() {
      this.base.newData = [];
      this.base.updateData = [];
      setTimeout(() => {
        this.base.fetchRecords();
      }, 100);
    },
    onLoading(e) {
      this.loading = e;
      this.$emit('fetching', this.loading);
    },
    onSaving(e) {
      this.saving = e;
    },
    visibleSaveBtn(value) {
      this.showSaveBtn = value;
    },
    visibleDeleteBtn(value) {
      this.showDeleteBtn = value;
    },
    addNewEntry() {
      this.base.addRow();
    },
    async deleteEntry() {
      this.deleting = true;
      if (await this.$root.$confirm.open(
        'Delete record(s)',
        'Are you sure you want to delete?',
      )) {
        if (this.base.gridApi.getSelectedRows()) {
          const selectedRow = this.base.gridApi.getSelectedRows();
          const name = this.id;
          let deleted = '';
          await Promise.all([
            selectedRow.forEach((row) => {
              // eslint-disable-next-line
              const id = row._id;
              deleted = this.deleteRecord({ id, name });
            }),
          ]);
          if (deleted) {
            this.setAlert({
              show: true,
              type: 'success',
              message: 'DELETE_RECORD',
            });
            await this.base.deleteSelectedRows();
          } else {
            this.setAlert({
              show: true,
              type: 'error',
              message: 'ERROR_DELETE_RECORD',
            });
          }
          this.base.newData = [];
          this.showSaveBtn = false;
        }
      }
      this.deleting = false;
    },
    saveNewEntry() {
      this.base.saveModifiedRecords();
    },
    onBtnExport() {
      this.base.exportData();
    },
    downloadSample() {
      this.base.downloadSampleCSV();
    },
    refreshUi() {
      this.base.refreshData();
    },
    uploadFile() {
      this.$refs.uploader.click();
    },
    resetForm() {
      this.$refs.uploader.value = null;
    },
    onFilesChanged(e) {
      this.$refs.importer.importCSV(e);
    },
  },
};
</script>
